import { tournamentEngine } from 'tods-competition-factory';

import { config } from 'config/config';
import { setDev } from 'config/setDev';

export function setup() {
  setEnv();
  return config.init().then(ready);
}

function ready() {
  setDev();
  console.log('%c TMX Ready', 'color: lightgreen');
}

function setEnv() {
  const cfv = tournamentEngine.version();
  console.log(`%cfactory: ${cfv}`, 'color: lightblue');
}
